import base64Conversion from './base64conversion';

const studentActivationInfo = (object) => {
  const header = base64Conversion();
  // const localurl = '/360isuite_standalone/digitalStudentId';

  const isDisplayModeStandalone = window.matchMedia('(display-mode: standalone)').matches;

  const objToBeSent = {
    school_code: object.school_code,
    student_id: object.student_id,
    student_no: object.student_no,
    is_app_installed: isDisplayModeStandalone ? 'Yes' : 'No',
  };

  fetch(`${process.env.REACT_APP_API_HEAD}/setStudentLastActiveData`, {
    method: 'POST',
    body: JSON.stringify(objToBeSent),
    headers: {
      'Content-Type': 'application/json',
      Authorization: header,
    },
  })
    .then((res) => res.json())
    .then((res) => {
       // console.log(res.message);
    })
    .catch((error) => {
       // console.log(error.message);
    });
};

export default studentActivationInfo;
